const backs = document.querySelectorAll('.methodic__back');

backs.forEach((back) => {
  back.addEventListener('click', () => {
    history.back();
  });
});
